<!-- @format -->

<template>
    <div class="gst-empty-state-card-wrapper">
        <div class="gst-empty-state-card__content">
            <h4 class="gst-empty-state-card-title">{{ title }}</h4>
            <h6 class="gst-empty-state-card-message">{{ message }}</h6>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmptyStateCard',
    props: {
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-empty-state-card-wrapper {
    .gst-empty-state-card__content {
        .gst-empty-state-card-title {
            line-height: line-height('xxxxl');
            font-size: font-size('xxl');
            font-weight: font-weight('bold');
        }

        .gst-empty-state-card-message {
            line-height: line-height('xxxxl');
            font-size: font-size('l');
            font-weight: font-weight('regular');
        }
    }
}
</style>
